<template>
  <!-- 默认弹窗 -->
  <template v-if="type === 'close'">
    <ClosePopup ref="popupRef" v-bind="closePopupProps" @close="close" @manual-close="manualClose">
      <template #header>
        <slot name="header"></slot>
      </template>
      <template #content>
        <slot name="content"></slot>
      </template>
      <template #other>
        <slot name="other"></slot>
      </template>
    </ClosePopup>
  </template>

  <!-- 全屏弹窗 -->
  <template v-else-if="type === 'fullScreen'">
    <FullScreenPopup ref="popupRef" v-bind="fullScreenPopupProps" @close="close">
      <template #content>
        <slot name="content"></slot>
      </template>
    </FullScreenPopup>
  </template>

  <!-- 容器弹窗 -->
  <template v-else-if="type === 'container'">
    <ContainerPopup ref="popupRef" v-bind="containerPopupProps" @close="close">
      <template #content>
        <slot name="content"></slot>
      </template>
    </ContainerPopup>
  </template>
</template>

<script setup>
const popupRef = ref(null)

const props = defineProps({
  vanPopupStyle: { type: Object, default: () => {} },
  type: {
    type: String,
    default: 'close',
    validator: (value) => ['close', 'fullScreen', 'container'].includes(value),
  },
  closeType: { type: String, default: 'default' },
  title: { type: String, default: '' },
  position: { type: [Number, String], default: 'center' },
  height: { type: [Number, String], default: 100 },
  closeable: { type: Boolean, default: true },
  closeOnClickOverlay: { type: Boolean, default: false },
  padding: { type: [Number, String], default: 10 },
  radius: { type: [Number, String], default: 15 },
  background: { type: String, default: '' },
  borderSize: { type: [Number, String], default: 1 },
  borderColor: { type: String, default: '' },
})

const closePopupProps = computed(() => {
  const { type, ...rest } = props
  return rest
})

const fullScreenPopupProps = computed(() => {
  const { vanPopupStyle, height, closeOnClickOverlay, position } = props
  return { vanPopupStyle, height, closeOnClickOverlay, position }
})

const containerPopupProps = computed(() => {
  const { vanPopupStyle, type, position, closeable, ...rest } = props
  return rest
})

const close = () => {
  emit('close')
}
const manualClose = () => {
  emit('manualClose')
}

const emit = defineEmits(['close', 'manualClose'])

defineExpose({
  open: () => popupRef.value?.open(),
  close: () => popupRef.value?.close(),
  manualClose: () => popupRef.value?.manualClose(),
})
</script>
